import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useField } from "formik";
import { Box, FormControl, Button } from "@mui/material";
import { CustomFieldLabel } from "../CustomFieldLabel/CustomFieldLabel";
import { FieldError } from "../FieldError/FieldError";
import previewImg from "./image-placeholder.jpg";

export function CustomFieldImageUpload({
  name,
  label,
  required,
  hideInput = false,
  ...props
}) {
  const [field, meta, helpers] = useField(name);
  const [img, setImg] = useState(field.value || previewImg);
  const fileInputRef = useRef(null);

  const handleAvatarClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  useEffect(() => {
    if (field.value) {
      setImg(field.value);
    } else {
      setImg(previewImg);
    }
  }, [field.value]);

  const handleDeleteClick = () => {
    setImg(previewImg);
    helpers.setValue("");
    props.onChange({ source: "", file: null, extension: "" });

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const imageChange = (event) => {
    const { files } = event.target;
    if (files.length > 0) {
      const target = files[0];
      if (target.size < 15000000) {
        const fReader = new FileReader();
        fReader.readAsDataURL(target);
        fReader.onloadend = function (e) {
          setImg(e.target.result);
          helpers.setValue(e.target.result);
          props.onChange({
            source: e.target.result,
            file: target,
            extension: target.type.replace("image/", ""),
          });

          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        };
      } else {
        toast.error("File exceeds maximum upload size.");
      }
    }
  };

  return (
    <FormControl className="field-container" fullWidth={props.fullWidth}>
      <div>
        {label && (
          <CustomFieldLabel required={required}>{label}</CustomFieldLabel>
        )}
        <div className="flex items-start gap-5 mb-[4px]">
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            name={field.name}
            onChange={imageChange}
            style={{ display: "none" }}
          />
          <Box
            sx={{
              width: "114px",
              height: "114px",
              minWidth: "114px",
              minHeight: "114px",
              cursor: "pointer",
              overflow: "hidden",
              borderRadius: "12px",
              backgroundColor: "var(--surface-2)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={handleAvatarClick}
          >
            <img
              src={img}
              alt="pro headshot"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            />
          </Box>

          <div className="flex flex-col gap-3 justify-start">
            <Button
              variant="contained"
              size="large"
              style={{ textTransform: "none" }}
              onClick={handleAvatarClick}
            >
              Upload Image
            </Button>
            <Button
              sx={{
                color: "var(--Base-900, #444)",
                fontFamily: "CircularStd",
                fontSize: "14px",
                height: "40px",
                fontStyle: "normal",
                fontWeight: 900,
                lineHeight: "normal",
                textTransform: "none",
                border: "none",
                backgroundColor: "var(--surface-2)",
              }}
              onClick={handleDeleteClick}
              disabled={img === previewImg}
              size="large"
            >
              Delete Image
            </Button>
          </div>
        </div>
        <CustomFieldLabel>
          <span className="text-text-1 text-xs">Recomended:</span>{" "}
          <span className="text-xs">min size: 600x600px | .jpeg /.png</span>
        </CustomFieldLabel>
      </div>

      {!!meta.touched && !!meta.error && <FieldError>{meta.error}</FieldError>}
    </FormControl>
  );
}

CustomFieldImageUpload.defaultProps = {
  label: "",
  required: false,
};
